import React from 'react';

export const pageMeta = {
  "name": "Object Reference",
  "link": "/javascript/objects/reference"
};

export default function JavascriptObjectsReference() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Object Reference</h2>
      <p>Route: /javascript/objects/reference</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
